/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBan = createReactComponent("ban", "IconBan", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M5.7 5.7l12.6 12.6", key: "svg-1" }]
]);

export { IconBan as default };
//# sourceMappingURL=IconBan.js.map
